import React from 'react';
import { RadioButtonGroupProps, useInputHelper, FormFieldsData, RadioButtonGroup } from 'framework/form';

const RadioButtonGroupExtended = ({
  transformSubmitData,
  ...props
}: RadioButtonGroupProps & {
  transformSubmitData?: (values: FormFieldsData) => Promise<FormFieldsData>;
}) => {
  const { getRawOnChangeCallback } = useInputHelper({ ...props });

  const onChange = getRawOnChangeCallback();

  const handleChange = async (data: FormFieldsData) => {
    const fixedData = await transformSubmitData?.(data);
    onChange?.(fixedData || data);
  };

  return <RadioButtonGroup {...props} onChangeCallback={handleChange} />;
};

export default RadioButtonGroupExtended;
